import {
  isStringVr,
  isPrivateTag,
  parsePN,
  parseTM,
  parseDA,
  explicitElementToString,
  explicitDataSetToJS,
  createJPEGBasicOffsetTable,
} from './util/index.js';

import { parseDicomDataSetExplicit, parseDicomDataSetImplicit } from './parseDicomDataSet.js';
import { readFixedString } from './byteArrayParser.js';

import alloc from './alloc.js';
import version from './version.js';
import bigEndianByteArrayParser from './bigEndianByteArrayParser.js';
import ByteStream from './byteStream.js';
import sharedCopy from './sharedCopy.js';
import DataSet from './dataSet.js';
import findAndSetUNElementLength from './findAndSetUNElementLength.js';
import findEndOfEncapsulatedElement from './findEndOfEncapsulatedPixelData.js';
import findItemDelimitationItemAndSetElementLength from './findItemDelimitationItem.js';
import littleEndianByteArrayParser from './littleEndianByteArrayParser.js';
import parseDicom from './parseDicom.js';
import readDicomElementExplicit from './readDicomElementExplicit.js';
import readDicomElementImplicit from './readDicomElementImplicit.js';
import readEncapsulatedImageFrame from './readEncapsulatedImageFrame.js';
import readEncapsulatedPixelData from './readEncapsulatedPixelData.js';
import readEncapsulatedPixelDataFromFragments from './readEncapsulatedPixelDataFromFragments.js';
import readPart10Header from './readPart10Header.js';
import readSequenceItemsExplicit from './readSequenceElementExplicit.js';
import readSequenceItemsImplicit from './readSequenceElementImplicit.js';
import readSequenceItem from './readSequenceItem.js';
import readTag from './readTag.js';

const dicomParser = {
  isStringVr,
  isPrivateTag,
  parsePN,
  parseTM,
  parseDA,
  explicitElementToString,
  explicitDataSetToJS,
  createJPEGBasicOffsetTable,
  parseDicomDataSetExplicit,
  parseDicomDataSetImplicit,
  readFixedString,
  alloc,
  version,
  bigEndianByteArrayParser,
  ByteStream,
  sharedCopy,
  DataSet,
  findAndSetUNElementLength,
  findEndOfEncapsulatedElement,
  findItemDelimitationItemAndSetElementLength,
  littleEndianByteArrayParser,
  parseDicom,
  readDicomElementExplicit,
  readDicomElementImplicit,
  readEncapsulatedImageFrame,
  readEncapsulatedPixelData,
  readEncapsulatedPixelDataFromFragments,
  readPart10Header,
  readSequenceItemsExplicit,
  readSequenceItemsImplicit,
  readSequenceItem,
  readTag,
};

export {
  isStringVr,
  isPrivateTag,
  parsePN,
  parseTM,
  parseDA,
  explicitElementToString,
  explicitDataSetToJS,
  createJPEGBasicOffsetTable,
  parseDicomDataSetExplicit,
  parseDicomDataSetImplicit,
  readFixedString,
  alloc,
  version,
  bigEndianByteArrayParser,
  ByteStream,
  sharedCopy,
  DataSet,
  findAndSetUNElementLength,
  findEndOfEncapsulatedElement,
  findItemDelimitationItemAndSetElementLength,
  littleEndianByteArrayParser,
  parseDicom,
  readDicomElementExplicit,
  readDicomElementImplicit,
  readEncapsulatedImageFrame,
  readEncapsulatedPixelData,
  readEncapsulatedPixelDataFromFragments,
  readPart10Header,
  readSequenceItemsExplicit,
  readSequenceItemsImplicit,
  readSequenceItem,
  readTag,
};

export default dicomParser;
